export default __webpack_public_path__ + "static/media/face.87a92c05.jpg";